var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(2134 3333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(-2130 -3329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344",
    transform: "translate(-63 -1850)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 16,
    height: 16,
    transform: "translate(-2071 -1483)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_48a5a45b6e609be5d8e072af17c353fb",
    "data-name": "48a5a45b6e609be5d8e072af17c353fb",
    d: "M8.969,15.938A6.969,6.969,0,1,0,2,8.969,6.969,6.969,0,0,0,8.969,15.938ZM6.386,8.476a.7.7,0,0,1,.985,0l.9.9,2.295-2.295a.7.7,0,1,1,.985.985L8.765,10.855a.7.7,0,0,1-.985,0L6.386,9.462A.7.7,0,0,1,6.386,8.476Z",
    transform: "translate(-2071.969 -1483.969)",
    fill: "#2ec900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f310d002bb7b3dd74197d6746ee7450b.svg";
export { ForwardRef as ReactComponent };